import { getSVGImageUrl } from 'lib/image/imageUtils'
import React from 'react'

const whyWorkForUsItems = [
  {
    title: 'Discounted Luxury Escapes Travel',
    text: 'Our team receive up to 20% off Luxury Escapes products.',
    icon: <img src={getSVGImageUrl('careers-tiles-bestpriceguarantee')} alt="best price guarantee" height="68" />,
  },
  {
    title: 'Birthday Leave',
    text: 'Celebrate your special day by taking ½ a day off and receiving a $50 Luxury Escapes credit.',
    icon: <img src={getSVGImageUrl('careers-tiles-birthday')} alt="birthday" height="68" />,
  },
  {
    title: 'Fitness',
    text: 'Gyms on site or corporate gym memberships options available at discounted rates.',
    icon: <img src={getSVGImageUrl('careers-tiles-fitness')} alt="fitness" height="68" />,
  },
  {
    title: 'Health & Wellbeing Program',
    text: 'Annual flu shots, lunch and learn sessions with health professionals, access to the LE employee assistance program.',
    icon: <img src={getSVGImageUrl('careers-tiles-wellbeing')} alt="wellbeing" height="68" />,
  },
  {
    title: 'Baby Bonus and Partner Leave',
    text: 'Having a Bub? Enjoy 8 weeks bonus pay as primary carer!',
    icon: <img src={getSVGImageUrl('careers-tiles-dad_partner_pay')} alt="dad partner pay" height="68" />,
  },
  {
    title: 'Break to Donate',
    text: 'Feel like donating blood? Take paid time off to do so!',
    icon: <img src={getSVGImageUrl('careers-tiles-blood')} alt="blood" height="68" />,
  },
  {
    title: 'Flexibility',
    text: 'Fun, dynamic and flexible work environment. ',
    icon: <img src={getSVGImageUrl('careers-tiles-flexibility')} alt="flexibility" height="68" />,
  },
  {
    title: 'Regular Networking Events',
    text: 'Celebration and recognition prizes, ping pong onsite, wine tastings and much more! ',
    icon: <img src={getSVGImageUrl('careers-tiles-team_building')} alt="team building" height="68" />,
  },
  {
    title: 'Learning & Development',
    text: 'Build your career with Leadership Programs sponsored by our CEO, eLearning courses and onsite workshops.',
    icon: <img src={getSVGImageUrl('careers-tiles-learning')} alt="learning" height="68" />,
  },
  {
    title: 'Refer a Friend',
    text: 'Know someone who has what it takes to join the LE team? Enjoy a $2500 referral reward for successfully referring someone to LE!',
    icon: <img src={getSVGImageUrl('careers-tiles-referral')} alt="referral" height="68" />,
  },
  {
    title: 'Breakfast and Lunches',
    text: 'Breakfast and lunches supplied, along with fresh fruit and coffee.',
    icon: <img src={getSVGImageUrl('careers-tiles-breakfast')} alt="breakfast" height="68" />,
  },
  {
    title: 'Culture First',
    text: 'We look to add to our culture with every hire – you don’t need to conform to succeed here. ',
    icon: <img src={getSVGImageUrl('careers-tiles-culture')} alt="culture" height="68" />,
  },
  {
    title: 'Seamless Communication',
    text: 'Stay in the loop with fortnightly newsletter updates and regular team meetings on both a global and local scale. ',
    icon: <img src={getSVGImageUrl('careers-tiles-communication')} alt="communication" height="68" />,
  },
  {
    title: 'Purchase Annual Leave Program',
    text: 'Fancy some extra time off each year? We offer a purchase leave program of up to an additional 4 weeks per year. ',
    icon: <img src={getSVGImageUrl('careers-tiles-illustration_calendar')} alt="calendar" height="68" />,
  },
  {
    title: 'Novated Lease Program',
    text: 'Looking for a new set of wheels? Purchase a new or used car through our motor vehicle novated leasing program. ',
    icon: <img src={getSVGImageUrl('careers-tiles-illustration_car')} alt="car" height="68" />,
  },
  {
    title: 'Familiarisation Trips',
    text: 'Immerse yourself in the same luxurious travel experiences that our customers enjoy. ',
    icon: <img src={getSVGImageUrl('careers-tiles-illustration_map')} alt="map" height="68" />,
  },
  {
    title: 'Holiday and Experience Giveaways',
    text: 'Luxury Escapes is super generous with our team with regular giveaways of credit to our team members and holidays at our Xmas celebrations! ',
    icon: <img src={getSVGImageUrl('careers-tiles-illustration_tickets')} alt="tickets" height="68" />,
  },
  {
    title: 'Hallmark Day Celebrations',
    text: 'At Luxury Escapes we like to celebrate the extraordinary and the ordinary, join in for international cuisine days, donut day and more. ',
    icon: <img src={getSVGImageUrl('careers-tiles-illustration_celebrate')} alt="celebrate" height="68" />,
  },
  {
    title: 'Loyalty Reward',
    text: 'On your yearly anniversary of service with Luxury Escapes, we will gift you either a credit or a discount code to use on a fabulous Luxury Escapes holiday!',
    icon: <img src={getSVGImageUrl('careers-tiles-loyalty-reward')} alt="wellbeing" height="68" />,
  },
]

export default whyWorkForUsItems
